var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,13.75c-2.34,0-7,1.17-7,3.5V19H16V17.25C16,14.92,11.34,13.75,9,13.75ZM4.34,17A9.642,9.642,0,0,1,9,15.75,9.642,9.642,0,0,1,13.66,17Z",
    fill: "#2e80c3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,12A3.5,3.5,0,1,0,5.5,8.5,3.5,3.5,0,0,0,9,12ZM9,7A1.5,1.5,0,1,1,7.5,8.5,1.5,1.5,0,0,1,9,7Z",
    fill: "#2e80c3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.04,13.81A4.193,4.193,0,0,1,18,17.25V19h4V17.25C22,15.23,18.5,14.08,16.04,13.81Z",
    fill: "#2e80c3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15,12a3.5,3.5,0,0,0,0-7,3.446,3.446,0,0,0-1.5.35,5.461,5.461,0,0,1,0,6.3A3.446,3.446,0,0,0,15,12Z",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4921b6f3d671dca7c99193063c287da3.svg";
export { ForwardRef as ReactComponent };